/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
/* biome-ignore-all lint/suspicious/noArrayIndexKey: legacy array indices */
import type { TablePaginationConfig, TableProps } from "antd"
import { Table, Typography } from "antd"
import type React from "react"

const { Text } = Typography
import { Link } from "react-router-dom"
import { useTableScroll } from "@/hooks/useTableScroll"
import "@/styles/table.full.css"

interface PhrasalVerbTableProps {
  data: any[]
  loading: boolean
  selectedRowKeys: React.Key[]
  onSelectionChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => void
  pagination?: TableProps["pagination"]
}

const PhrasalVerbTable: React.FC<PhrasalVerbTableProps> = ({
  data,
  loading,
  selectedRowKeys,
  onSelectionChange,
  pagination,
}) => {
  const { scrollConfig, tableWrapperRef } = useTableScroll()

  const columns: TableProps["columns"] = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 80,
      align: "center",
      render: (value: number) => <span className="font-semibold">{value}</span>,
    },
    {
      title: "Cụm động từ",
      dataIndex: "phrase",
      key: "phrase",
      width: 200,
      render: (value: string) => <span className="font-bold text-primary">{value}</span>,
    },
    {
      title: "Từ gốc",
      dataIndex: "head_word",
      key: "head_word",
      width: 150,
      render: (head_word: any) => {
        if (!head_word) return <Text type="secondary">—</Text>
        return (
          <Link to={`/dict/headword/${head_word.id}`} className="font-semibold hover:underline">
            {head_word.word}
          </Link>
        )
      },
    },
    {
      title: "Ý nghĩa & Định nghĩa",
      key: "senses",
      render: (_: any, record: any) => {
        const senses = record.senses
        if (!senses || senses.length === 0) return <Text type="secondary">—</Text>
        return (
          <div className="flex flex-col gap-2">
            {senses.map((sense: any, index: number) => (
              <div key={sense.id || index} className="text-xs">
                <div>
                  <Text strong>
                    {index + 1}. {sense.meaning}
                  </Text>
                </div>
                {sense.definition && (
                  <div className="mt-1 pl-4">
                    <Text type="secondary" italic>
                      {sense.definition}
                    </Text>
                  </div>
                )}
              </div>
            ))}
          </div>
        )
      },
    },
  ]

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectionChange,
  }

  return (
    <div className="min-h-0 min-w-0 flex-1" ref={tableWrapperRef}>
      <Table
        bordered
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        rowSelection={rowSelection}
        pagination={pagination as TablePaginationConfig}
        scroll={{ x: "100%", y: scrollConfig.y }}
        size="small"
        classNames={{
          root: "full-height-table",
        }}
      />
    </div>
  )
}

PhrasalVerbTable.displayName = "PhrasalVerbTable"

export default PhrasalVerbTable
